/**
 * Provides live site-copy (admin-editable) to the app. Falls back to hardcoded
 * defaults instantly so first paint is never blank.
 */
import React, { createContext, useContext, useEffect, useState } from 'react';
import { api } from '@/lib/api';

const DEFAULTS = {
    'hero.overline': 'S.M.I. // FACILITY 00 · TRANSMISSION ONLINE',
    'hero.headline': 'The synthetic-media investigations facility.',
    'hero.subline': 'Synthetic Media Investigators learn AI from the inside — we uncover the data, protect the truth and our digital and intellectual rights, teach the world how AI works, and build automations that benefit humanity.',
    'banner.enabled': false,
    'banner.text': '',
    'banner.href': '',
    'academy.hero.headline': 'The Academy is free for everyone.',
    'academy.hero.subline': "Observer tier — no signup required for most of it.",
    'roadmap.hero.overline': 'S.M.I. // DIRECTIVE 09 · ROADMAP DECLASSIFIED',
    'roadmap.hero.title': 'The Roadmap.',
    'roadmap.hero.subline': "A public planning document for a facility that's evolving from an education platform into trust infrastructure for a world where humans and AI create together.",
    'roadmap.hero.mission': "S.M.I. exists to establish trust, ownership, and authenticity in human–AI co-creation. We help creators verify who they are, preserve the provenance of what they make, protect their IP through documentation and evidence, and improve how their work is discovered by AI-driven search.\n\nWe don't promise to stop deepfakes, block bots, or guarantee authenticity. We build the tools, records, and signals that let humans decide — with better evidence in front of them.",
    'roadmap.closing.body': 'This roadmap represents direction and intent — not guarantees, not fixed timelines, and not a finished map. Scope, sequencing, and naming will evolve as the field evolves and as we learn what actually helps creators. Everything on this page is subject to change as S.M.I. moves through each phase.',
    'landing.poem': '',
    'landing.signature': 'SYNTHETIC MEDIA INVESTIGATOR',
    'landing.tagline': 'Learn AI. Uncover the data. Protect the truth.',
    'landing.enter_label': 'ENTER THE AI ACADEMY',
    'landing.newsletter_prompt': 'Or receive the signal from here.',
    'landing.newsletter_success': 'Signal received.',
};

const SiteCopyContext = createContext(DEFAULTS);

export const SiteCopyProvider = ({ children }) => {
    const [copy, setCopy] = useState(DEFAULTS);
    useEffect(() => {
        api.get('/site-copy').then(({ data }) => {
            setCopy({ ...DEFAULTS, ...(data || {}) });
        }).catch(() => {});
    }, []);
    return <SiteCopyContext.Provider value={copy}>{children}</SiteCopyContext.Provider>;
};

export const useSiteCopy = (key) => {
    const copy = useContext(SiteCopyContext);
    return key ? copy[key] : copy;
};
